import { types } from "../../types/types";

export const initialState = {
  referrals: [],
  allPatients: new Map(),
  statesDervCtrl: [],
};

export const customerCareReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.loadReferrals:
      return {
        ...state,
        referrals: action.payload,
      };

    // case types.loadPatients:
    //   return {
    //     ...state,
    //     allPatients: action.payload,
    //   };

      case types.loadPatients:
      const { payload } = action;
      const value = [...payload.value];

      let patientOfCountry = payload.patients.get(payload.key);

      if (payload.actionDoc !== "removed") {
        if (!patientOfCountry) {
          patientOfCountry = [...value]
        } else {

          if (payload.actionDoc === "added") {
            patientOfCountry.push(...value);
          } else {
            patientOfCountry = [...value]
          }
        };
      } else {
        patientOfCountry = [...value]
      }

      // patientOfCountry.sort((a, b) =>
      //   a["timestamp"] - b["timestamp"]
      // );

      payload.patients.set(payload.key, patientOfCountry);

      return {
        ...state,
        allPatients: payload.patients,
      };


    case types.loadStateDervCtrl:
      return {
        ...state,
        statesDervCtrl: action.payload,
      };

    default:
      return state;
  }
};
